export const COOKIE_NAMES = {
    cookieAcceptance: "cookieAcceptance",
    userPreference: "userPreference",
    emailId: "emailId",
    byPassAuthen: "byPassAuthentication",
    userOrgData: "userOrgData"
}